export const ACCEPTED_COOKIE = 'aparcandgo_cookies_accepted';
export const LANG_STORAGE = 'lang';
export const LANG_STORAGE_REGEX = /es_ES|ca_ES|en_EN|fr_FR|es-ES|ca-ES|en-EN|fr-FR|es|ca|en|fr/;
